import {SEND_PHONE_NUMBER_STARTED} from "../../reducers/signinReducer";

export const submitPhoneStarted = () =>{
    return {
        type: SEND_PHONE_NUMBER_STARTED,
        payload: {}
    }
}